var React = require('react');

function Hmbr (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"line top","d":"m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5 0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20","key":0}),React.createElement("path",{"className":"line middle","d":"m 70,50 h -40","key":1}),React.createElement("path",{"className":"line bottom","d":"m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5 0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20","key":2})]);
}

Hmbr.defaultProps = {"className":"ham hamRotate ham4","viewBox":"0 0 100 100","width":"60"};

module.exports = Hmbr;

Hmbr.default = Hmbr;
